import './style.scss';

export function our_mission_block() {
  const block = document.querySelector('.our_mission_block');
  if (!block) return;
  
}
  